import axios from "axios";

export default function AddCourse(){
    
    function submitHandler(e){
       
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.post(`${process.env.REACT_APP_BASE_URL}api/course/secured/createCourse`,data)
        .then(result=>{alert("Create Successfully!");window.location.href="/course"})
        .catch(err=>alert(err.response.data));
    }

    return(<div className="container">
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                         <div className="col-12 col-sm-3">
                            <input className="form-control" type="text" name="name" placeholder="Name" required />
                        </div>
                        <div className="col-12 col-sm-3">
                            <input className="form-control" type="text" name="description" placeholder="Description" required />
                        </div>
                        <div className="col-12 col-sm-3">
                            <button className="btn btn-color">Add</button>
                        </div> 
                </div> 
            </form>
        </div>
    </div>);
}